import { VariableWeight } from '~/icons'

export default function CartListItemVariantWeight() {
  return (
    <p className="color-gray-60">
      <VariableWeight className="inline-block mr-1 mb-[0.1875rem]" />
      <span className="text-xs tracking-tight">Peso Variável</span>
    </p>
  )
}
